export const stringToBool = (value: string | boolean | undefined | null): boolean => {
  if (typeof value === 'boolean') {
    return value;
  }

  if (!value) {
    return false;
  }

  const lowerValue = value?.toLowerCase();
  if (lowerValue === 'true') {
    return true;
  }

  if (lowerValue === 'false') {
    return false;
  }

  return false;
};

// maybe one of these will be thought of by a future dev looking for this...
export const parseBool = stringToBool;
export const cBool = stringToBool;
